/* eslint-disable @typescript-eslint/no-explicit-any */
import { PHONE_CODE } from "@/constants/constants.ts";

import { userNameToNFC } from "./utils";

/**
 * Validate email format
 *
 * @param email - Email to validate
 * @returns True if valid, false otherwise
 */
export function isValidEmail(email: string): boolean {
  // 限制总长度254位
  // if (email.length > 254) return false;

  // // 检查是否包含连续的点号
  // if (email.includes("..")) return false;

  // // 检查是否以点号开头或结尾
  // if (email.startsWith(".") || email.endsWith(".")) return false;

  // // 使用更严格的 Unicode 正则 (ES2018+)
  // // 确保域名部分不以点号结尾，顶级域名只包含字母数字和连字符
  // const emailRegex =
  //   /^(?!\.)(?!.*\.\.)[A-Za-z0-9._-]{1,64}(?<!\.)@([A-Za-z0-9-]+\.)+[A-Za-z]{2,63}$/;

  // return emailRegex.test(email);
  // TODO

  if (email.length > 254) return false;
  if (email.includes("..")) return false;
  if (email.startsWith(".") || email.endsWith(".")) return false;

  const emailRegex =
    /^[A-Za-z0-9](\.?[A-Za-z0-9_-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,63}$/;

  return emailRegex.test(email);
}

/**
 * Validate phone number format (simple validation)
 *
 * @param phone - Phone number to validate
 * @returns True if valid, false otherwise
 */
export function isValidPhone(
  countryCode: string,
  phone: string,
  regex?: string,
): boolean {
  if (countryCode === `+${PHONE_CODE}` || countryCode === PHONE_CODE) {
    const repeatingDigitsRegex = /^(\d)\1{9}$/; // 连续10位相同的数字

    // 检查是否为重复数字
    if (repeatingDigitsRegex.test(phone)) {
      return false;
    }

    // 限制必须是10位数字（墨西哥号码都是10位）
    return /^\d{10}$/.test(phone);
  }
  return regex ? new RegExp(regex).test(phone) : /^[1-9]\d{5,10}$/.test(phone);
}

export function isValidCPF(cpf: string): boolean {
  // 去除非数字字符
  cpf = cpf.replace(/[^\d]+/g, "");

  // 检查是否为11位数字
  if (cpf.length !== 11) return false;

  // 排除所有数字都一样的情况，例如 "00000000000"
  if (/^(\d)\1+$/.test(cpf)) return false;

  // 校验第1位校验码
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let check1 = (sum * 10) % 11;
  if (check1 === 10 || check1 === 11) check1 = 0;
  if (check1 !== parseInt(cpf.charAt(9))) return false;

  // 校验第2位校验码
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }
  let check2 = (sum * 10) % 11;
  if (check2 === 10 || check2 === 11) check2 = 0;
  if (check2 !== parseInt(cpf.charAt(10))) return false;

  return true;
}

export function isValidPassword(password: string): boolean {
  // 检查长度是否在6-30位之间
  if (password.length < 6 || password.length > 30) {
    return false;
  }
  const passwordRegex = new RegExp(
    "^[0-9a-zA-Z!@#$%^&*()_+-=,./<>?;':\\\"\\[\\]\\\\\\{\\}|`~]{6,30}$",
  );
  return passwordRegex.test(password);
}

export function isValidAccount(account: string): boolean {
  const accountRegex = /^[a-zA-Z0-9]{6,16}$/;
  return accountRegex.test(account);
}

export function isValidInviteCode(inviteCode: string): boolean {
  // const inviteCodeRegex = /^[a-zA-Z0-9]{6,30}$/;

  return true;
}

export function isPasswordMatch(
  password: string,
  confirmPassword: string,
): boolean {
  return password === confirmPassword;
}

//年满18周岁
export function isAdult(birthDateStr: string): boolean {
  const [year, month, day] = birthDateStr.split("-").map(Number);
  const birthDate = new Date(year, month - 1, day); // 注意：month 从 0 开始

  const today = new Date();
  const adultDate = new Date(
    birthDate.getFullYear() + 18,
    birthDate.getMonth(),
    birthDate.getDate(),
  );

  return today >= adultDate;
}
// cpf
export function isValidCpf(cpf: string): boolean {
  cpf = cpf || "";
  let add = 0;
  let rev = 0;
  let i = 0;
  if (((cpf = cpf.replace(/[^\d]+/g, "")), "" == cpf)) return !1;
  if (
    11 != cpf.length ||
    "00000000000" == cpf ||
    "11111111111" == cpf ||
    "22222222222" == cpf ||
    "33333333333" == cpf ||
    "44444444444" == cpf ||
    "55555555555" == cpf ||
    "66666666666" == cpf ||
    "77777777777" == cpf ||
    "88888888888" == cpf ||
    "99999999999" == cpf
  )
    return !1;
  for (add = 0, i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
  if (
    ((rev = 11 - (add % 11)),
    (10 == rev || 11 == rev) && (rev = 0),
    rev != parseInt(cpf.charAt(9)))
  )
    return !1;
  for (add = 0, i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
  return (
    (rev = 11 - (add % 11)),
    (10 == rev || 11 == rev) && (rev = 0),
    rev != parseInt(cpf.charAt(10)) ? !1 : !0
  );
}
export function isValidCnpj(cnpj: string): boolean {
  if (!cnpj) return false;

  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj === "") return false;

  if (cnpj.length !== 14) return false;

  if (
    cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999"
  )
    return false;

  let tamanho: number = cnpj.length - 2;
  let numeros: string = cnpj.substring(0, tamanho);
  const digitos: string = cnpj.substring(tamanho);
  let soma = 0;
  let pos: number = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(0))) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(1))) return false;

  return true;
}
// 验证真实名字
export function isRealName(value: string) {
  if (!value) return false;
  const name = userNameToNFC(value);
  if (name.trim().length < 2 || name.trim().length > 60) {
    return false;
  }
  return true;
}
// 验证银行分号
export function isBankBranch(value: string) {
  if (!value) return false;
  const regex = /^\d{1,30}$/;
  return regex.test(value);
}
// 验证正整数，不能为0
export function isPositiveInteger(value: string) {
  if (value.trim()) return false;
  return /^[1-9]\d*$/.test(value);
}
// 验证银行账号
export function isBankAccountNumber(value: string) {
  if (value.trim()) return false;
  return /^[0-9-]{1,30}$/.test(value);
}
// 验证传入正则
export function isCustomRegular(value: string, regex: string) {
  const regexp = new RegExp(regex);
  return regexp.test(value);
}
// 验证cpf的值
export function isCpfValue(value: string) {
  return /^[\d.-]+$/.test(value);
}
// 字符串转正则
export function parseRegexString(str: string) {
  // 匹配以斜杠开头和结尾的正则字符串，如 "/abc/g"
  const match = str.match(/^\/(.*)\/([a-z]*)$/i);

  if (match) {
    const pattern = match[1];
    const flags = match[2];
    try {
      return new RegExp(pattern, flags);
    } catch (e: unknown) {
      console.error("RegExp 构造失败:", (e as Error).message);
      return null;
    }
  } else {
    console.warn("不是合法的正则格式，例如应为：/abc/g");
    return null;
  }
}

export const isValidNotEmpty = (value: any) =>
  value !== null &&
  value !== undefined &&
  value !== "null" &&
  value !== "undefined" &&
  value !== "";
